import { Accounts, Pagination } from '@factorin/domain';

import { withUrl, list, post, put, remove, ItemRequest } from '../rest';


interface AccountListRequest extends Pagination.Request {
    bankUid: string;
}

interface CreateChangeAccountItem {
    item: {
        BankUid: string;
        DebtorUid: string;
        ClientUid: string;
        Currency: string;
        Number: string;
    };
}

const accountsPart = withUrl('accounts');
export const accounts = {
    ...list<Accounts.Account, AccountListRequest>(accountsPart()),
    create: post<CreateChangeAccountItem, Accounts.Account>(
        ({ item }) => accountsPart({
            body: item,
        }),
    ),
    update: put<ItemRequest & CreateChangeAccountItem, Accounts.Account>(
        ({ id, item }) => accountsPart({
            path: `${id}`,
            body: item,
        }),
    ),
    remove: remove<ItemRequest, void>(
        ({ id }) => accountsPart({
            path: `${id}`,
        }),
    ),
};
